import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';

import { apiUrlGenerator } from '../use-api';
import { showResult } from '../utils';

import type { IPartialPaginationMeta } from 'infrastructure/interfaces';

export type TCareManagersFilter = {
  fullName?: string;
  clinicalRoles?: string;
  minPatientsAssigned?: number;
  maxPatientsAssigned?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc' | '';
} & IPartialPaginationMeta;

export type TCareManagersItem = {
  guid: string;
  firstName: string;
  lastName: string;
  patientCount: number;
};

export type TCareManagersRes = {
  count: number;
  rows: TCareManagersItem[];
};

export const CARE_MANAGERS_PER_PAGE = 20;
export const GET_CARE_MANAGERS_KEY = 'getCareManagersKey';

const getCareManagersFn = async (filter: TCareManagersFilter) => {
  const url = 'core-2/transfer-tool/care-managers';
  const { data, error } = await dataService.getList<TCareManagersRes>(
    apiUrlGenerator(url, filter),
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};
const getCareManagersKey = (filter: TCareManagersFilter) => [
  GET_CARE_MANAGERS_KEY,
  filter,
];

export const useGetCareManagers = (filter: TCareManagersFilter) => {
  const filterWithItems: TCareManagersFilter = {
    ...filter,
    items: CARE_MANAGERS_PER_PAGE,
  };

  const { data, isLoading, isFetching } = useQuery({
    queryKey: getCareManagersKey(filterWithItems),
    queryFn: async () => getCareManagersFn(filterWithItems),
    keepPreviousData: true,
  });

  return { data, isLoading, isFetching };
};
